function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import produce from 'immer';
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { ApprovalMethodDateModel } from "../ApprovalMethodDateModel";
import { PriceIncreaseModel } from "../PriceIncreaseModel";
import { IntegratedClassType, ServiceIntegrationsModel } from "../ServiceIntegrations";
import { ServiceStatusType } from "./model";
import * as selectors from "./selectors";
export function makeChanges(changes) {
  return {
    name: changes.name != null ? changes.name : null,
    description: changes.description != null ? changes.description : null,
    cost: changes.cost != null ? changes.cost : null,
    billing: changes.billing != null ? changes.billing : null,
    bundle: changes.bundle != null ? changes.bundle : null
  };
}
export function matchStatusType(status, matcher) {
  switch (status.type) {
    case ServiceStatusType.AwaitingApproval:
      return matcher.awaitingApproval(status);
    case ServiceStatusType.Amended:
      return matcher.amended(status);
    case ServiceStatusType.Approved:
      return matcher.approved(status);
    case ServiceStatusType.Completed:
      return matcher.completed(status);
    case ServiceStatusType.Terminated:
      return matcher.terminated(status);
    case ServiceStatusType.Canceled:
      return matcher.canceled(status);
  }
}
export const makeRepeatableManualStatus = service => {
  return matchStatusType(service.status, {
    awaitingApproval: status => {
      return _objectSpread(_objectSpread({}, status), {}, {
        awaitingApproval: _objectSpread(_objectSpread({}, status.awaitingApproval), {}, {
          effectiveDate: null,
          effectiveDateSource: null
        })
      });
    },
    amended: status => {
      return _objectSpread(_objectSpread({}, status), {}, {
        amended: _objectSpread(_objectSpread({}, status.amended), {}, {
          effectiveDate: null,
          effectiveDateSource: null
        })
      });
    },
    approved: status => {
      return _objectSpread(_objectSpread({}, status), {}, {
        approved: _objectSpread(_objectSpread({}, status.approved), {}, {
          effectiveDate: null,
          effectiveDateSource: null
        })
      });
    },
    completed: status => {
      return _objectSpread(_objectSpread({}, status), {}, {
        completed: _objectSpread(_objectSpread({}, status.completed), {}, {
          effectiveDate: null,
          effectiveDateSource: null
        })
      });
    },
    terminated: status => {
      return status;
    },
    canceled: status => {
      return status;
    }
  });
};
export const makeOneTimeAutomaticStatus = makeRepeatableManualStatus;
export const makeOneTimeManualStatus = makeRepeatableManualStatus;
export const makeOnApprovalStatus = makeRepeatableManualStatus;
export const makeOneTimeInStagesStatus = makeRepeatableManualStatus;
export function makeAwaitingApprovalStatus() {
  var _options$effectiveDat, _options$effectiveDat2;
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: ServiceStatusType.AwaitingApproval,
    awaitingApproval: {
      addedOn: options.addedOn || new Date(),
      approvalMethod: options.approvalMethod || ApprovalMethodDateModel.makeManual(),
      note: options.note || null,
      limitedTimeDiscountOffer: options.limitedTimeDiscountOffer,
      effectiveDate: (_options$effectiveDat = options.effectiveDate) !== null && _options$effectiveDat !== void 0 ? _options$effectiveDat : null,
      effectiveDateSource: (_options$effectiveDat2 = options.effectiveDateSource) !== null && _options$effectiveDat2 !== void 0 ? _options$effectiveDat2 : null
    }
  };
}
export function makeAmendedStatus() {
  var _options$effectiveDat3, _options$effectiveDat4;
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: ServiceStatusType.Amended,
    date: options.date || new Date(),
    amended: {
      amendedOn: options.amendedOn || new Date(),
      changes: makeChanges(options.changes || {}),
      approvalMethod: options.approvalMethod || ApprovalMethodDateModel.makeManual(),
      note: options.note || null,
      effectiveDate: (_options$effectiveDat3 = options.effectiveDate) !== null && _options$effectiveDat3 !== void 0 ? _options$effectiveDat3 : null,
      effectiveDateSource: (_options$effectiveDat4 = options.effectiveDateSource) !== null && _options$effectiveDat4 !== void 0 ? _options$effectiveDat4 : null
    }
  };
}
export function makeApprovedStatus(_ref) {
  let {
    date,
    effectiveDate,
    effectiveDateSource
  } = _ref;
  return {
    type: ServiceStatusType.Approved,
    date,
    approved: {
      effectiveDate: effectiveDate !== null && effectiveDate !== void 0 ? effectiveDate : null,
      effectiveDateSource: effectiveDateSource !== null && effectiveDateSource !== void 0 ? effectiveDateSource : null
    }
  };
}
export function makeCompletedStatus(date, changes) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    effectiveDate,
    effectiveDateSource
  } = options;
  const status = {
    type: ServiceStatusType.Completed,
    date,
    completed: {
      effectiveDate: effectiveDate !== null && effectiveDate !== void 0 ? effectiveDate : null,
      effectiveDateSource: effectiveDateSource !== null && effectiveDateSource !== void 0 ? effectiveDateSource : null
    }
  };
  if (changes) {
    status.completed.changes = makeChanges(changes);
  }
  return status;
}
export function makeTerminatedStatus(date) {
  return {
    type: ServiceStatusType.Terminated,
    date
  };
}
export function makeCanceledStatus() {
  return {
    type: ServiceStatusType.Canceled
  };
}
export function makeService(input) {
  var _input$id, _input$isBillable, _input$participation;
  let service = {
    id: (_input$id = input.id) !== null && _input$id !== void 0 ? _input$id : generateUniqueId('service'),
    name: input.name,
    description: input.description,
    status: input.status,
    cost: input.cost,
    billing: input.billing,
    isBillable: (_input$isBillable = input.isBillable) !== null && _input$isBillable !== void 0 ? _input$isBillable : false,
    serviceTemplateId: input.serviceTemplateId,
    participation: (_input$participation = input.participation) !== null && _input$participation !== void 0 ? _input$participation : makeMandatoryParticipation(),
    integrations: input.integrations || ServiceIntegrationsModel.fromDTO(undefined),
    source: input.source,
    bundle: input.bundle
  };
  if (!selectors.supportsPriceIncrease(service)) {
    service = produce(service, s => {
      s.cost.priceIncrease = PriceIncreaseModel.makeNone();
    });
  }
  return service;
}
export function makeMandatoryParticipation() {
  return {
    type: 'mandatory'
  };
}
export function makeOptionalParticipation(includedByDefault) {
  return {
    type: 'optional',
    optional: {
      includedByDefault
    }
  };
}
export function makeIntegratedClassUnset() {
  return {
    type: IntegratedClassType.Unset
  };
}
export function makeIntegratedClassSet(id) {
  return {
    type: IntegratedClassType.Set,
    set: {
      id
    }
  };
}